import { regex } from "../helpers/util";
import { CookieType, Tracking } from "../helpers/enums";
import { trackEvent } from "../tracking/helpers";

export const newsletter = () => {
  /* Consts */
  const newsletterForm = document.querySelector("[js-newsletter-form]");
  const newsletterinputContainer = document.querySelector(
    "[js-newsletter-input-container]"
  );
  const newsletterValidationMsg = document.querySelector(
    "[js-newsletter-validation-msg]"
  );
  const newsletterSuccessMsg = document.querySelector(
    "[js-newsletter-success-msg]"
  );
  const newsletterSubtext = document.querySelector("[js-newsletter-subtext]");
  const currentPage = newsletterForm?.getAttribute("js-current-page");

  if (!newsletterForm || !newsletterinputContainer) {
    return;
  }

  /* Form submition */
  newsletterForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const email = document.querySelector<HTMLInputElement>("#newsletterEmail");

    const languageCookie = document.cookie.match(
      new RegExp(`(^| )${CookieType.LANGUAGE}=([^;]+)`)
    );

    /* Hide button and reset validation */
    newsletterForm.querySelector("#newsletterSubmit")?.classList.add("hidden");
    newsletterinputContainer.classList.remove("invalid-field--bottom");
    newsletterValidationMsg?.classList.add("hidden");

    /* Validate email */
    if (!email || email.value.length > 100 || !regex.EMAIL.test(email.value)) {
      /* Show error message */
      newsletterinputContainer.classList.add("invalid-field--bottom");
      newsletterValidationMsg?.classList.remove("hidden");
      newsletterForm
        .querySelector("#newsletterSubmit")
        ?.classList.remove("hidden");
      return;
    }

    if (languageCookie && email) {
      submitData({
        email: email.value,
        language: languageCookie[2].toLowerCase(),
      });
    }
  });

  const submitData = async ({
    email,
    language,
  }: {
    email: string;
    language: string;
  }) => {
    const response = await fetch("/DotDigital/api/AddContacts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        currentPage: Number(currentPage),
        emailAddress: email,
        language,
      }),
    });

    if (response.status !== 200) {
      newsletterForm
        .querySelector("#newsletterSubmit")
        ?.classList.remove("hidden");
      return;
    }

    /* Success, hide form and show success message */
    newsletterinputContainer.remove();
    newsletterSubtext?.remove();
    newsletterSuccessMsg?.classList.remove("hidden");

    trackEvent({ eventName: Tracking.NEWSLETTER_SIGNUP });
  };
};
